
import React, { useState } from "react"
import { Accordion, Button, ButtonGroup, FormCheck, Dropdown, ListGroup, Spinner } from "react-bootstrap"
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

const sessions = [
    "2025K",
    "2024S",
    "2024K",
    "2023S",
    "2023K",
    "2022S",
    "2022K"
]
let gatherSession = null
function grout(student) {
    let out = ""
    let studentgrades = Object.values(student.grades)
    studentgrades.sort()   
    studentgrades.reverse()
    studentgrades.forEach((grade) => out += grades[grade] + " ")
    return out.substring(0, out.length-1)
}

function rnd(n) {
    return Math.floor(n * 100) / 100
}

function total(student) {
    let total = 0
    Object.values(student.grades).forEach(grade => {
        total += grade
    })
    return total
}

function letteravg(avg) {
    let rem = avg - Math.floor(avg)
    avg = Math.floor(avg)
    let remstr = ""
    if (rem >= 0.75) {
        remstr = "-"
        avg = avg + 1
    } else if (rem >= 0.49) {
        remstr = "½"
    } else if (rem >= 0.25) {
        remstr = "+"
    }
    return grades[avg] + remstr
}

const grades = ["I", "ERROR", "A", "B", "C", "M", "E", "L"]
const sijaluvut = ["nollassa", "yhdessä", "kahdessa", "kolmessa", "neljässä", "viidessä", "kuudessa", "seitsemässä", "kahdeksassa", "yhdeksässä", "kymmenessä"]

export function SchoolEntry(school) {
    console.log(school)
    let session = school.session
    school = school.school
    
    let [students, setStudents] = useState(null)
    let [settings, setSettings] = useState({sort: "Keskiarvo", filters: [], enableFilters: false, session: session, loading: false})
    if (school == null) return
    if (students == null || students.name !== school || settings.session !== session) {
        if (settings.loading) return
        console.log("Fetching school details. Students is null: " + (students == null))

        setSettings({
            ...settings,
            loading: true
        })
        fetch("https://mallivastaukset-cdn-sxxnp.ondigitalocean.app/statistics/new/"+session+"/school/"+school)
            .then(response => {
                if (!response.ok) throw new Error("Network error")
                return response.json()
                
            })
            .then(data => {
                gatherSession = session
                if (!data.success || !data.hasOwnProperty("name")) {
                    setStudents({
                        success: false,
                        error: "Palvelimen virhe. " + (typeof(data.error) === "string" ? "Tarkemmin: " + data.error : ""),
                        name: school
                    })

                } else {
                    setStudents(data)
                }
                setSettings({sort: "Keskiarvo", filters: [], enableFilters: false, session: session, loading: false})
                
            }) 
            .catch((error) => {
                setStudents({
                    success: false,
                    error: "Virhe yhteydenotossa. Tarkemmin: " + error.toString(),
                    name: school
                })
                setSettings({sort: "Keskiarvo", filters: [], enableFilters: false, session: session, loading: false})
            })
            return (
                <div style={{minHeight:"100vh"}}></div>
            )
    } else {

        if (students && !students.success) {
            return (
                <div>
                    <p>Palvelimessa tapahtui virhe.</p>
                    <p>Mahdolliset lisätiedot: <b>{students.error}</b></p>
                    <p>Mikäli virhe jatkuu, ota meihin yhteyttä sivun alareunan linkistä.</p>
                </div>
            )
        }
        

        let handleSortOrderChange = ((event) => {
            setSettings({
                ...settings,
                sort: event.target.textContent
            })
            event.preventDefault()
        })
        let handleAddFilter = ((event) => {
            let filters = settings.filters
            filters.push(event.target.id.substring(4))
            setSettings({
                ...settings,
                filters: filters
            })
            event.preventDefault()
        })
        let handleRemoveFilter = ((event) => {
            let filters = settings.filters
            filters.splice(filters.indexOf(event.target.id.substring(4)), 1)
            setSettings({
                ...settings,
                filters: filters
            })
            event.preventDefault()
        })
        let handleToggleFilterEnabled = ((event) => {
            setSettings({
                ...settings,
                enableFilters: !settings.enableFilters
            })
        })

        let getHeaderString = ((student, item) => {
            if (settings.sort === "Pisteet") {
                return (
                    <>
                        <b>#{student.number+ 1} </b> 
                        &nbsp; 
                        {rnd(student.total)}
                        <span className="HideOnMobile">
                            &nbsp;pistettä
                        </span>
                        &nbsp; 
                        &nbsp;
                        <span style={{color: "#787b7d"}}> 
                            <span className="HideOnMobile">
                                Koearvosanat&nbsp;
                            </span> 
                            <span className="ShowOnMobile">
                                (
                            </span>
                            {grout(student)}
                            <span className="ShowOnMobile">
                                )
                            </span>
                            <span className="HideOnMobile">
                                &nbsp;- {student.sex === 1 ? "mies" : "nainen"}
                            </span>
                        </span>
                    </>
                );
                
            } else {
                return (
                    <>
                        <b>#{student.number + 1} </b> 
                        &nbsp; 
                        <span className="HideOnMobile">
                            Keskiarvo&nbsp;
                        </span>
                        {letteravg(student.average)} 
                        &nbsp; 
                        &nbsp;
                        <span style={{color: "#787b7d"}}> 
                            <span className="HideOnMobile">
                                Koearvosanat&nbsp;
                            </span> 
                            <span className="ShowOnMobile">
                                (
                            </span>
                            {grout(student)}
                            <span className="ShowOnMobile">
                                )
                            </span>
                            <span className="HideOnMobile">
                                &nbsp;- {student.sex === 1 ? "mies" : "nainen"}
                            </span>
                        </span>
                    </>
                )
            }
        })

        let subjects = {}
        students.students.forEach(student => {
            Object.keys(student.grades).forEach(grade => {
                if (!subjects.hasOwnProperty(grade)) subjects[grade] = 0
                subjects[grade]+= 1
            })
        })
        let rankedSubjects = []
        Object.keys(subjects).forEach(subject => {
            if (!settings.filters.includes(subject)) rankedSubjects.push({name: subject, students: subjects[subject]})
        })
        // sort by number of students or in alphabetical order?
        //rankedSubjects.sort((a,b) => a.students - b.students)
        rankedSubjects.sort((a,b) => {
            return students.dictionary[a.name].localeCompare(students.dictionary[b.name])
        })

        let shownStudents = []
        let sortableStudents = students.students

        // sort
        if (settings.sort === "Pisteet") {
            sortableStudents.sort((a,b) => a.total - b.total)
            sortableStudents.reverse()
        } else {
            sortableStudents.sort((a,b) => a.average - b.average)
            sortableStudents.reverse()
        }

        sortableStudents.forEach((student, index) => {
            shownStudents.push({
                ...student,
                number: index
            })
        })
        // filter
        if (settings.filters.length > 0 && settings.enableFilters) {
            shownStudents = shownStudents.filter(student => {
                let allow = true;
                settings.filters.forEach(filter => {
                    if (!student.grades.hasOwnProperty(filter)) allow = false
                })
                return allow
            })
        }
        let prizeemoji = ((position) => {
            if (position === 1) return "🥇"
            if (position === 2) return "🥈"
            if (position === 3) return "🥉"
            return ""
        })
        let subjectsForRankings = []
        let highestPosition = 99
        let subjectInHighest = undefined
        for (let [subjectname, subject] of Object.entries(students.basics.subjects)) {
            if (subject.rank < highestPosition) {
                highestPosition = subject.rank
                subjectInHighest = subjectname
            } else if (subject.rank === highestPosition) subjectInHighest = (typeof(subjectInHighest) === "number" ? subjectInHighest + 1 : 2)
            subjectsForRankings.push({...subject, name: subjectname})
        }
        let highestSubjectsString = "virhe!"
        if (typeof(subjectInHighest) == "string") {
            highestSubjectsString = "aineessa " + students.dictionary[subjectInHighest]
        } else highestSubjectsString = (subjectInHighest < sijaluvut.length ? sijaluvut[subjectInHighest] : subjectInHighest + ":ssa") + " aineessa!"
        

        subjectsForRankings.sort((a,b) => a.rank - b.rank)
        
        let verbalRating = "Heikko"
        if (students.basics.ratings?.helsinki >= -0.3) verbalRating = "Kohtalainen"
        if (students.basics.ratings?.helsinki >= 0.0) verbalRating = "Hyvä"
        if (students.basics.ratings?.helsinki >= 0.8) verbalRating = "Erinomainen"

        let verbalRating2 = "huomattavasti huonommin"
        if (students.basics.ratings?.helsinki >= -0.4) verbalRating2 = "huonommin"
        if (students.basics.ratings?.helsinki >= -0.2) verbalRating2 = "suunnilleen yhtä hyvin"
        if (students.basics.ratings?.helsinki >= 0.2) verbalRating2 = "paremmin"
        if (students.basics.ratings?.helsinki >= 0.4) verbalRating2 = "huomattavasti paremmin"

        let averageEntryGPA = 0
        students.basics.entryGPA.forEach(c => averageEntryGPA += c.gpa)
        averageEntryGPA = rnd(averageEntryGPA / students.basics.entryGPA.length)
        return (
            <>
                <div className="StatsSchoolInfoContainer">
                    <InfoModule desc="Keskiarvo" rank={students.basics.averageRank} figure={letteravg(students.basics.average)}/>
                    <InfoModule desc="Valmistunutta" rank={students.basics.graduatesRank} figure={students.basics.graduates}/>
                    <InfoModule desc="Laudatureita per oppilas" rank={students.basics.lpsRank} figure={rnd(students.basics.lps)}/>
                </div>
                {(subjectInHighest !== undefined || students.basics.entryGPA.length > 0 || students.basics.ratings?.helsinki !== undefined) && 
                    <hr></hr>
                }
                


                {subjectInHighest !== undefined && 
                    <Accordion className="StatsStudentContainer">
                        <Accordion.Header>
                            <div style={{display: "flex"}} className="MobileFlexAlign">
                            <h3 style={{paddingRight: "0.5em"}}className="MonospaceFont"><b>Lukion ainekohtaiset keskiarvot</b> </h3>
                            <h5 className="MonospaceFont CenterVerticallyInDiv"><span className="HideOnMobile">Suomen&nbsp;</span> #{highestPosition} {highestSubjectsString}</h5>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                        <ListGroup>
                        {Array.from({ length: subjectsForRankings.length}).map((_, item) => (
                            <ListGroup.Item className="MonospaceFont" style={{background: "#faf3de"}}>
                            <div className="HideOnMobile">
                                {prizeemoji(subjectsForRankings[item].rank)} <b>{students.dictionary[subjectsForRankings[item].name]}</b>&nbsp; Keskiarvo: {letteravg(subjectsForRankings[item].average)} ({rnd(subjectsForRankings[item].average)}). Sija: <b>#{subjectsForRankings[item].rank}</b> Suomessa. ({subjectsForRankings[item].count} kirjoittajaa)
                            </div>
                            <div className="ShowOnMobile">
                                <p>{prizeemoji(subjectsForRankings[item].rank)} <b>{students.dictionary[subjectsForRankings[item].name]}</b></p>
                                <p>Keskiarvo: {letteravg(subjectsForRankings[item].average)} ({rnd(subjectsForRankings[item].average)})</p>
                                <p>#{subjectsForRankings[item].rank} Suomessa ({subjectsForRankings[item].count} kirjoittajaa)</p>
                            </div>
                            </ListGroup.Item>
                        ))}
                        </ListGroup>
                        <br></br>
                        <i className="MonospaceFont">Näytetään vain ne aineet, joilla oli yli 5 kirjoittajaa. Suomessa on <b>{students.schoolCount}</b> lukiota (ml. aikuislukiot), mutta monissa lukioissa oppilaat eivät kirjoita kaikkia aineita.</i>
                        </Accordion.Body>
                    </Accordion>
                }

                {students.basics.entryGPA.length > 0 && 
                    <Accordion className="StatsStudentContainer">
                        <Accordion.Header>
                            <div style={{display: "flex"}} className="MobileFlexAlign">
                            <h3 style={{paddingRight: "0.5em"}}className="MonospaceFont"><b>Lukion yleislinjan pääsyraja</b> </h3>
                            <h5 className="MonospaceFont CenterVerticallyInDiv">{(students.basics.entryGPA.length > 1 ? students.basics.entryGPA[0].year + "-"+students.basics.entryGPA.at(-1).year + " keskiarvo: " : students.basics.entryGPA[0].year  + ": ") + averageEntryGPA}</h5>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                        <ListGroup>
                        {Array.from({ length: students.basics.entryGPA.length}).map((_, item) => (
                            <ListGroup.Item className="MonospaceFont" style={{background: "#faf3de"}}>
                                {students.basics.entryGPA.at(-item - 1).likelyThis && 
                                    <>
                                        <b>
                                            {students.basics.entryGPA.at(-item - 1).year}:
                                        </b>
                                        &nbsp;
                                        <b>
                                            Pääsyraja {students.basics.entryGPA.at(-item - 1).gpa}&nbsp;
                                            {students.basics.entryGPA.at(-item - 2) !== undefined && 
                                                <>
                                                    ({students.basics.entryGPA.at(-item - 1).gpa - students.basics.entryGPA.at(-item - 2).gpa >= 0 ? "+" : ""}{Math.round((students.basics.entryGPA.at(-item - 1).gpa - students.basics.entryGPA.at(-item - 2).gpa) * 100) / 100})
                                                </>
                                            }
                                        </b>
                                    </>
                                }
                                {!students.basics.entryGPA.at(-item - 1).likelyThis && 
                                    <><b>{students.basics.entryGPA.at(-item - 1).year}:</b>&nbsp;Pääsyraja {students.basics.entryGPA.at(-item - 1).gpa} {students.basics.entryGPA.at(-item - 2) !== undefined && <>({students.basics.entryGPA.at(-item - 1).gpa - students.basics.entryGPA.at(-item - 2).gpa >= 0 ? "+" : ""}{Math.round((students.basics.entryGPA.at(-item - 1).gpa - students.basics.entryGPA.at(-item - 2).gpa) * 100) / 100})</> }</>
                                }
                            </ListGroup.Item>
                        ))}
                        </ListGroup>
                        <br></br>
                        {students.basics.entryGPA.find(s => s.likelyThis) !== undefined && 
                            <i className="MonospaceFont">Vuosi <b>{students.basics.entryGPA.find(s => s.likelyThis).year}</b> on korostettu, koska se on kolme vuotta ennen tätä valmistumista. Suurin osa lukiolaisista valmistuu kolmessa vuodessa, joten moni näistä valmistujista on valittu tällä pääsyrajalla. Tilaston lähde: YLE / Opetusministeriön tilastopalvelu</i>
                        }
                        </Accordion.Body>
                    </Accordion>
                }
                {students.basics.ratings?.helsinki !== undefined && 
                    <Accordion className="StatsStudentContainer">
                        <Accordion.Header>
                            <div style={{display: "flex"}} className="MobileFlexAlign">
                            <h3 style={{paddingRight: "0.5em"}}className="MonospaceFont"><b>Helsinkiläisten lukioiden vertailu</b> </h3>
                            <h5 className="MonospaceFont CenterVerticallyInDiv">{verbalRating}</h5>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body className="MonospaceFont">
                            <p>Tämän lukion oppilaiden YO-todistuksen keskiarvo on <b>{Math.abs(students.basics.ratings.helsinki)} {students.basics.ratings.helsinki >= 0 ? "korkeampi" : "matalampi"}</b> kuin mitä sen pääsyrajan perusteella ennustaisi.</p>
                            <p>Tämä tarkoittaa sitä, että tästä lukiosta valmistunut oppilas on todennäköisesti suoriutunut <b>{verbalRating2}</b> ylioppilaskokeissa verrattuna hänen kaveriinsa, joka meni toiseen suunnilleen saman keskiarvorajan lukioon.</p>
                            <Accordion defaultActiveKey={-1}>
                                <Accordion.Item>
                                    <Accordion.Header>Lisätietoja</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Ennuste perustuu lineaariseen regressiomalliin, jossa otetaan huomioon Helsingin lukioista vuosina 2020-2024 valmistuneet sekä vastaavasti samojen lukioiden keskiarvorajat vuosina 2017-2021.</p>
                                        <p>Vertailu sisältää vain Helsingin lukiot siksi, että lukioissa on enemmän valinnanvaraa Helsingissä ja oppilaat valikoivat lukioita vahvemmin oman yläasteen keskiarvonsa perusteella.</p>
                                        <p>Tässä mallinnuksessa kannattaa muistaa, että siinä ei ole mahdollista huomioida muille kuin lukion yleislinjalle valittujen aloittajien suoriutumista. Tästä huolimatta mallin (trendiviivan) selitysaste R^2 on 84%.</p>
                                        <p>Ennusteesta merkittävästi poikkeavat lukiot ovat kiinnostavia. Niissä voi olla esimerkiksi <b>opetuksen tason, oppilaiden akateemisen tavoitteellisuuden tai lukion ilmapiirin</b> eroja.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Accordion.Body>
                    </Accordion>
                }
                <hr></hr>
                <div className="StatsStudentContainer">
                    <h3 className="MonospaceFont"><b>{(session.substring(4,5) === "S" ? "Syksyn " : "Kevään ") + session.substring(0,4)} valmistujat</b></h3>
                    <div className="StatsStudentListSettings">
                        <div>
                            <span className="MonospaceFont">Järjestys: <ButtonGroup>
                                <Button variant={(settings.sort === "Keskiarvo" ? "primary" : "outline-primary")} onClick={handleSortOrderChange}>Keskiarvo</Button>
                                <Button variant={(settings.sort === "Pisteet" ? "primary" : "outline-primary")} onClick={handleSortOrderChange}>Pisteet</Button>
                            </ButtonGroup></span>
                        </div>
                        <br></br>
                        <p><span className="MonospaceFont"><FormCheck style={{color: (settings.enableFilters ? "black" : "lightgray")}} type="switch" id="enable-filter-switch" label="Näytä vain ne, jotka kirjoittivat aineet " inline onClick={handleToggleFilterEnabled}/> 
                            {Array.from({ length: settings.filters.length }).map((_, item) => (
                                <>
                                    <Button className="MiniPill Removable" id={"rbn-" + settings.filters[item]} disabled={!settings.enableFilters} onClick={handleRemoveFilter}>{students.dictionary[settings.filters[item]]}</Button>
                                    &nbsp;ja&nbsp;
                                </>
                            ))}
                            <Dropdown inline className="InlineDiv">
                                <Dropdown.Toggle className="MiniPill" disabled={!settings.enableFilters} inline>+</Dropdown.Toggle>
                                <Dropdown.Menu>
                                    
                                    {Array.from({ length: rankedSubjects.length }).map((_, item) => (
                                        <Dropdown.Item onClick={handleAddFilter} id={"dds-"+rankedSubjects[item].name}> {students.dictionary[rankedSubjects[item].name]} ({rankedSubjects[item].students})</Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </span></p>
                    </div>
                    {students.basics.hidden > 0 && <i className="MonospaceFont" style={{color: "#rgb(120, 123, 125)", marginBottom: "2%"}}>{students.basics.hidden} valmistujan tietoja ei voida näyttää.</i>}
                    <Accordion>
                        {Array.from({ length: shownStudents.length }).map((_, item) => (
                            <Accordion.Item eventKey={item.toString()}>
                                <Accordion.Header className="MonospaceFont">
                                    {getHeaderString(shownStudents[item], item)}    
                                </Accordion.Header>
                                <Accordion.Body className="MonospaceFont">
                                    <p><b> <span className="ShowOnMobile">{shownStudents[item].sex === 1 ? "Mies" : "Nainen"}, YO-arvosanojen k</span><span className="HideOnMobile">K</span>eskiarvo {rnd(shownStudents[item].average)} ({letteravg(rnd(shownStudents[item].average))})</b></p>
                                    {Array.from({ length: Object.keys(shownStudents[item].grades).length }).map((_, gradekey) => (
                                        <p>{students.dictionary[Object.keys(shownStudents[item].grades)[gradekey]]} &nbsp; {grades[shownStudents[item].grades[Object.keys(shownStudents[item].grades)[gradekey]]]}</p>
                                    ))}
                                    <p><i>Pisteitä yhteensä {rnd(total(shownStudents[item]))}</i></p>
                                    {parseInt(students.percentiles.fiftiethPercentile) < Math.round(shownStudents[item].average * 100) / 100 && students.percentiles.hasOwnProperty((Math.round(shownStudents[item].average * 100) / 100).toString()) && (<p><b>Kokelas on kaikista Suomen valmistujista parhaiden {students.percentiles[(Math.round(shownStudents[item].average * 100) / 100).toString()]}% joukossa.</b></p>)}
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>
            </>
        )
    }
}

export function LeaderboardList(props) {
    //let subject = props.subject
    let handleOnSelect = props.handleOnSelect
    let leaderboard = props.leaderboard
    if (leaderboard === undefined) {
        return (
            <div style={{height: "50vh", justifyContent: "center", alignItems: "center", display:"flex", flexDirection: "column"}}>
                <Spinner animation="border" variant="secondary" role="status"></Spinner>
                <h5 style={{marginTop:"5vh", color:"rgba(107, 116, 124)"}}>Ladataan tietoja...</h5>
            </div>
        )
    } else if (!leaderboard.success) {
        return (
            <p>Palvelimessa tapahtui virhe. Mahdollisia lisätietoja: {leaderboard.error}</p>
        )
    } else {
        leaderboard = leaderboard.leaderboard
        return (
            <ListGroup>
                {Array.from({ length: leaderboard.length}).map((_, item) => (
                    <>
                        <ListGroup.Item key={item} style={{background: "#faf3de"}}>
                            <div className="MonospaceFont HideOnMobile">
                                <b className="UnderlineOnHover" onClick={() => {
                                    handleOnSelect(leaderboard[item])
                                    window.scrollTo({top: 0, left: 0, behavior: "instant"})
                                }}>
                                    {"#" + (item + 1) + " " + leaderboard[item].name}
                                </b>
                                &nbsp; keskiarvo {letteravg(leaderboard[item].average)} ({rnd(leaderboard[item].average)}),
                                {" " + leaderboard[item].count} kirjoittajaa
                            </div>

                            <div className="MonospaceFont ShowOnMobile" >
                                <p><b className="UnderlineOnHover" onClick={() => {
                                    handleOnSelect(leaderboard[item])
                                    window.scrollTo({top: 0, left: 0, behavior: "instant"})
                                }}>
                                    {"#" + (item + 1) + " " + leaderboard[item].name}
                                </b></p>
                                <p>Keskiarvo {letteravg(leaderboard[item].average)} ({rnd(leaderboard[item].average)})</p>
                                <p>{leaderboard[item].count} kirjoittajaa</p>
                            </div>
                        </ListGroup.Item>
                    </>
                ))}
            </ListGroup>
        )
    }
    
}

export function InfoModule(props) {
    return (
        <div className="StatsSchoolInfoContainerItem">
            <h4>
                {props.figure}
            </h4>
            <p>
                {props.desc}
                <br></br>
                <i>#{props.rank}&nbsp;Suomessa</i>
            </p>
        </div>
    )
}

export function SessionSelector(props) {
    let selectedSession = props.session
    let setSession = props.setSession
    let selectedSessionIndex = 0
    for (let s = 0; s <= sessions.length; s++) {
        if (sessions[s] === selectedSession) {
            selectedSessionIndex = s
        }
    }

    let humanSession = ((text) => {
        return (text.substring(4,5) === "S" ? "Syksy " : "Kevät ") + text.substring(0,4)
    })

    let previousSession = selectedSessionIndex + 1
    if (previousSession >= sessions.length) previousSession = -1

    let nextSession = selectedSessionIndex - 1
    if (nextSession < 0) nextSession = -1
    console.log("Sessions: next " + nextSession + ", previous " + previousSession)
    return (
        <>
            <div className="SessionContainer">
                {previousSession !== -1 && <h3 className="SessionHyperlink MonospaceFont" style={{marginRight:"auto"}}><a href="#!" onClick={(event) => {
                    setSession(sessions[previousSession])
                    event.preventDefault()
                }}><b> {"< " + humanSession(sessions[previousSession])}</b></a></h3>}
                {nextSession !== -1 && <h3 className="SessionHyperlink MonospaceFont" style={{marginLeft: "auto"}}><a href="#!" onClick={(event) => {
                    setSession(sessions[nextSession])
                    event.preventDefault()
                }}><b>{humanSession(sessions[nextSession]) + " >"}</b></a></h3>}
            </div>
            <hr></hr>
        </>
    )
}


export default function StatisticsPage() {

    const handleOnSelect = (item) => {
        window.history.replaceState(null, "", "/tilastot/?school=" + item.name)
        setSelectedSchool(item.name)

    }

    const formatResult = (item) => {
        return (
            <>
                <span style={{ display: 'block', textAlign: 'left', margin: "5px"}}>{item.name + " "}
                    <span class="Badge OutlineObject HideOnMobile">
                        {item.size} valmistunutta
                    </span>
                </span>
            </>
        )
    }
    let [session, setSession ] = useState(sessions[0])
    let [schools, setSchools ] = useState(null)
    let [leaderboard, setLeaderboard] = useState([])
    let [selectedSchool, setSelectedSchool ] = useState(null)
    let [subjectLeaderboards, setSubjectLeaderboards] = useState({})

    if (typeof(schools) === "string" && schools.startsWith("ERROR")) {
        return <p>Virhe: Palvelimessa tapahtui virhe. Yritä myöhemmin uudelleen. {schools.split(" -/- ")[1]}</p>
    }
    if (selectedSchool == null) { 
        document.getElementById("pageTitle").innerHTML = "Vuoden " + session.substring(0,4) + " " + (session.substring(4,5) === "S" ? "syksyn" : "kevään") + " ylioppilaat"
    } else {
        document.getElementById("pageTitle").innerHTML = session.substring(0,4) + " tilastot: " + selectedSchool
    }
    document.getElementById("pageDescription").content = "Täältä voit katsoa ylioppilaskokeiden koulukohtaiset tilastot sekä kattavat tiedot yksittäisten valmistujien suoriutumisesta ilmaiseksi."
    if (schools == null || (gatherSession !== session && selectedSchool == null)) {
        //console.log("Fetching school list. Typeof schools: " + typeof(schools) + ", selectedSchool: " + selectedSchool + ", gatherSession/session mismatch: " + (gatherSession !== session))
        fetch("https://mallivastaukset-cdn-sxxnp.ondigitalocean.app/statistics/new/"+session+"/school_list")
            .then(response => {
                if (!response.ok) throw new Error("Network error")
                return response.json()
            })
            .then(data => {
                if (!data.success) {
                    setSchools("ERROR -/- Lisätietoja:" + (data.error || ""))
                } else {
                    let out = []
                    gatherSession = session
                    setLeaderboard({overall: data.leaderboard, subjectBests: data.subjectBests})
                    for (var i in Object.keys(data.list)) {
                        out.push({
                            id: i,
                            name: Object.keys(data.list)[i],
                            size: data.list[Object.keys(data.list)[i]]
                        })
                    }

                    setSchools(out)
                    const queryParams = new URLSearchParams(window.location.search)
                    if (queryParams.get("school") !== null) {
                        setSelectedSchool(queryParams.get("school"))
                    }
                }
            }) 
            .catch((error) => {
                setSchools("ERROR")
                console.log(error)
            })
    } else {
        return (
            <>
                <div className="App-header">
                    <h3>
                        <b>Vuoden {session.substring(0,4) + " " + (session.substring(4,5) === "S" ? "syksyn" : "kevään")} ylioppila<span className="HideOnMobile">iden tilastot</span><span className="ShowOnMobile">at</span></b>
                    </h3>
                    <br></br>
                    <div className="SearchBox">
                        <ReactSearchAutocomplete
                            items={schools}
                            fuseOptions={{threshold: 0.3}}
                            onSelect={handleOnSelect}
                            showIcon={false}
                            autoFocus
                            placeholder="Syötä koulun nimi"
                            inputDebounce={50}
                            formatResult={formatResult}
                            styling={{
                                fontFamily: "Courier New",
                                borderRadius: "5px",
                                zIndex: "100",
                            }}
                        />
                    </div>
                    
                </div>
                <SessionSelector session={session} setSession={(sessioncandidate) => {
                    setSession(sessioncandidate)
                }}/>
                {selectedSchool == null &&
                    <>
                        <br></br>
                        <div className="StatsStudentContainer">
                            <h4 className="MonospaceFont" style={{textAlign: "center"}}><b>Korkeimpien keskiarvojen lukiot</b></h4>
                            <ListGroup>
                                {Array.from({ length: leaderboard.overall.length}).map((_, item) => (
                                    <>
                                        <ListGroup.Item key={item + 10000} className="MonospaceFont HideOnMobile" style={{background: "#faf3de"}}>
                                            <b className="UnderlineOnHover" onClick={() => {
                                                handleOnSelect(leaderboard.overall[item])
                                                window.scrollTo({top: 0, left: 0, behavior: "instant"})
                                            }}>
                                                {"#" + (item + 1) + " " + leaderboard.overall[item].name}
                                            </b>
                                            &nbsp; keskiarvo {rnd(leaderboard.overall[item].average)} ({letteravg(leaderboard.overall[item].average)}),
                                            {" " + leaderboard.overall[item].graduates} valmistunutta
                                        </ListGroup.Item>

                                        <ListGroup.Item key={item} className="MonospaceFont ShowOnMobile" style={{background: "#faf3de"}}>
                                            <p>
                                                <b className="UnderlineOnHover" onClick={() => {
                                                    handleOnSelect(leaderboard.overall[item])
                                                    window.scrollTo({top: 0, left: 0, behavior: "instant"})
                                                }}>{"#" + (item + 1) + " " + leaderboard.overall[item].name}</b>
                                            </p>
                                            <p>Keskiarvo: {letteravg(leaderboard.overall[item].average)} ({rnd(leaderboard.overall[item].average)}) </p>
                                            <p>Valmistuneita: {leaderboard.overall[item].graduates}</p>
                                        </ListGroup.Item>
                                    </>
                                ))}
                            </ListGroup>
                        </div>

                        <br></br>
                        <div className="StatsStudentContainer">
                            <h4 className="MonospaceFont" style={{textAlign: "center"}}><b>Parhaat lukiot aineittain</b></h4>
                            <Accordion>
                                {Array.from({ length: leaderboard.subjectBests.length}).map((_, item) => (
                                    <>
                                        <Accordion.Item style={{background: "#faf3de"}} eventKey={leaderboard.subjectBests[item].subject}>
                                            <Accordion.Header>
                                                <div className="MonospaceFont HideOnMobile">
                                                    <b>{leaderboard.subjectBests[item].subject}</b>:&nbsp;
                                                        <span className="UnderlineOnHover" onClick={() => {
                                                            handleOnSelect(leaderboard.subjectBests[item])
                                                            window.scrollTo({top: 0, left: 0, behavior: "instant"})
                                                        }}>
                                                        {leaderboard.subjectBests[item].name}&nbsp;
                                                    </span>
                                                    (keskiarvo {letteravg(leaderboard.subjectBests[item].average)}, {leaderboard.subjectBests[item].count} kirjoittajaa)
                                                </div>

                                                <div className="MonospaceFont ShowOnMobile">
                                                    <p><b>{leaderboard.subjectBests[item].subject}</b>:</p>  
                                                        {leaderboard.subjectBests[item].name}
                                                    <p>({letteravg(leaderboard.subjectBests[item].average)}, {leaderboard.subjectBests[item].count} kirjoittajaa)</p>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body onEntering={() => {
                                                console.log(leaderboard.subjectBests[item].subject)
                                                let subjectName = leaderboard.subjectBests[item].subject
                                                if (!subjectLeaderboards.hasOwnProperty(subjectName)) {
                                                    fetch("https://mallivastaukset-cdn-sxxnp.ondigitalocean.app/statistics/new/"+session+"/subject_top/"+subjectName)
                                                    .then(response => {
                                                        if (!response.ok) throw new Error("Network error")
                                                        return response.json()
                                                        
                                                    })
                                                    .then(data => {
                                                        if (!data.success || !data.hasOwnProperty("leaderboard")) {
                                                            setSubjectLeaderboards({
                                                                ...subjectLeaderboards,
                                                                [subjectName]: {
                                                                    success: false,
                                                                    error: "Palvelimen virhe. " + (typeof(data.error) === "string" ? "Tarkemmin: " + data.error : "")
                                                                }
                                                            })
                                                        } else {
                                                            setSubjectLeaderboards({
                                                                ...subjectLeaderboards,
                                                                [subjectName]: data
                                                            })
                                                        }
                                                        
                                                    }) 
                                                    .catch((error) => {
                                                        setSubjectLeaderboards({
                                                            ...subjectLeaderboards,
                                                            [subjectName]: {
                                                                success: false,
                                                                error: "Virhe yhteydenotossa. Tarkemmin: " + error.toString()
                                                            }
                                                        })
                                                    })
                                                }
                                                

                                            }}>
                                                <LeaderboardList subject={leaderboard.subjectBests[item].subject} leaderboard={subjectLeaderboards[leaderboard.subjectBests[item].subject]} handleOnSelect={handleOnSelect} />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </>
                                ))}
                            </Accordion>
                        </div>
                    </>
                }
                <SchoolEntry school={selectedSchool} session={session}/>
            </>
            
        )
    }
}